"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARD_ON_NEXT_STEP_COPY = exports.CARD_ON_STRIPE_PAGE_COPY = exports.START_TRIAL_METHOD_GROUP_LABEL_COPY = exports.START_TRIAL_PLAN_GROUP_LABEL_COPY = exports.PLAN_ANNUAL_LABEL_COPY = exports.PLAN_MONTHLY_LABEL_COPY = exports.PAYMENT_METHOD_CARD_COPY = exports.STRIPE_HANDLES_PAYMENTS_COPY = exports.DUE_TODAY_AMOUNT_COPY = exports.DUE_TODAY_LABEL_COPY = exports.START_TRIAL_BUTTON_COPY = exports.START_TRIAL_HEADING_COPY = void 0;
exports.startTrialPlanPrice = startTrialPlanPrice;
exports.startTrialSubline = startTrialSubline;
exports.startTrialFirstChargeDate = startTrialFirstChargeDate;
exports.startTrialChargeDay = startTrialChargeDay;
exports.startTrialFirstChargeLine = startTrialFirstChargeLine;
exports.START_TRIAL_HEADING_COPY = "Start your free trial";
exports.START_TRIAL_BUTTON_COPY = "Start free trial";
exports.DUE_TODAY_LABEL_COPY = "Due today";
exports.DUE_TODAY_AMOUNT_COPY = "$0.00";
exports.STRIPE_HANDLES_PAYMENTS_COPY = "Payments are handled securely by Stripe.";
exports.PAYMENT_METHOD_CARD_COPY = "Credit card";
exports.PLAN_MONTHLY_LABEL_COPY = "Monthly";
exports.PLAN_ANNUAL_LABEL_COPY = "Annual";
/** The two radiogroups' accessible names (Anthony's Sign-up board "2 · Start
 *  subscription": `role="radiogroup" aria-label="Plan"` / `"Payment method"`, §2). */
exports.START_TRIAL_PLAN_GROUP_LABEL_COPY = "Plan";
exports.START_TRIAL_METHOD_GROUP_LABEL_COPY = "Payment method";
/** Where the card fields are while Stripe's embedded form is off (report 167). */
exports.CARD_ON_STRIPE_PAGE_COPY = "You'll enter your card number, expiry and security code on Stripe's secure page.";
/** Where they are once the embedded form is on. */
exports.CARD_ON_NEXT_STEP_COPY = "You'll enter your card number, expiry and security code in the next step.";
const MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
/** "$10.99 a month" / "$109.00 a year · 2 months free" (the plan choice, D7). */
function startTrialPlanPrice(plan, price) {
    return plan === "monthly"
        ? `${price} a month`
        : `${price} a year · 2 months free`;
}
/**
 * The line under the heading, following the plan choice (D9):
 * "7 days free, then $10.99 a month. Cancel anytime." /
 * "7 days free, then $109.00 a year (2 months free). Cancel anytime."
 */
function startTrialSubline(plan, price, trialDays) {
    const then = plan === "monthly" ? `${price} a month` : `${price} a year (2 months free)`;
    return `${trialDays} days free, then ${then}. Cancel anytime.`;
}
/** The first charge falls on the sign-up day plus the trial (D11: Oct 27 → Nov 3). */
function startTrialFirstChargeDate(signupDay, trialDays) {
    const d = new Date(signupDay.getFullYear(), signupDay.getMonth(), signupDay.getDate());
    d.setDate(d.getDate() + trialDays);
    return d;
}
/** "Nov 3" (no Intl dependency, so both apps print it the same). */
function startTrialChargeDay(d) {
    return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}
/** "First charge of $109.00 on Nov 3 after your trial ends" (D10, screenshot wording). */
function startTrialFirstChargeLine(price, chargeDate) {
    return `First charge of ${price} on ${startTrialChargeDay(chargeDate)} after your trial ends`;
}
//# sourceMappingURL=startTrialCopy.js.map